
import { PickResponseSchema } from "slotworks/integration/revolver/schema/pick-record-schema";
import Record from "slotworks/model/gameplay/records/record";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class BonusResultBuilder implements ResultBuilder {

    public bonusId: string;
    public triggerAliases: string[];

    public filter(data: any): boolean {
        const response: PickResponseSchema = data as PickResponseSchema;

        let nextGameIsBonus;
        if (response && response.RESULTS && response.RESULTS.next_game) {
            nextGameIsBonus = response.RESULTS.next_game === this.bonusId;
            if (this.triggerAliases) {
                for (const alias of this.triggerAliases) {
                    if (response.RESULTS.next_game === alias) {
                        nextGameIsBonus = true;
                        break;
                    }
                }
            }
        }

        return nextGameIsBonus;
    }

    public build(record: Record, data: any): Result[] {
        const bonusResult = new BonusResult(this.bonusId);

        return [bonusResult];
    }
}

export default new BonusResultBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/results/bonus-result-builder.ts